module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eENL8"))).then(() => module.bundle.root('1iHdE'));